import { LitElement, html, css } from 'lit';

export class ListFrame extends LitElement {
	static styles = css`
    :host {
      position: relative;
      display: grid;
      width: auto;
      margin: var(--spacing-xl) 0;
      row-gap: var(--spacing-xl);
      grid-gap: var(--spacing-xl);
      grid-template-columns: repeat(auto-fill, 1fr);
    }
  `;

	render() {
		return html`<slot></slot>`;
	}
}

customElements.define('studio-gallery-list-frame', ListFrame);
